import { MainImages } from '@lemon/assets';
import { headers } from '../layout/header/Header';

export const Definition = () => {
    return (
        <img
            className="w-full h-[484px] xl:h-[1080px] object-cover"
            src={MainImages.problem}
            alt="Inspirational Background"
            onDragStart={e => e.preventDefault()}
        />
    );
};
